module.exports = __webpack_public_path__ + "img/money-bill-wave-alt.da2bc69c.svg";